import reduxThunk from "redux-thunk";
import { save, load } from "redux-localstorage-simple";
// import { configureStore } from "@reduxjs/toolkit";
import { reducer as idle } from "../lib/redux-idle-monitor/index.js";
import { actions as idleActions } from "../lib/redux-idle-monitor/index.js";
import { middleware as idleMiddleware } from "../lib/redux-idle-monitor/index.js";
import userReducer from "./user";
import dashboardReducer from "./dashboard";
import profileReducer from "./profile";
import settingsReducer from "./settings";
import diaryReducer from "./diary";
import tableFilterReducer from "./tableFilter";
import globalFiltersReducer from "./globalFilters.js";
import appStateReducer from "./appstate";
/*
import {
    persistStore,
    persistReducer,
    persistCombineReducers,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";*/
// import { PersistGate } from "redux-persist/integration/react";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  legacy_createStore as createStore,
  combineReducers,
  applyMiddleware,
} from "redux";

/*const persistConfig = {
    key: "root",
    version: 1,
    storage,
};

const persistedReducers = persistCombineReducers(persistConfig, {
    user: userReducer,
    appstate: appStateReducer,
});*/

const store = createStore(
  combineReducers({
    user: userReducer,
    dashboard: dashboardReducer,
    profile: profileReducer,
    settings: settingsReducer,
    diary: diaryReducer,
    tableFilter: tableFilterReducer,
    globalFilters: globalFiltersReducer,
    appstate: appStateReducer,
    idle,
  }),
  load({ states: ["appstate", "user", "dashboard"] }),
  composeWithDevTools(
    // applyMiddleware(routerMiddleware(browserHistory)),
    applyMiddleware(reduxThunk, idleMiddleware),
    applyMiddleware(save({ states: ["appstate", "user", "dashboard"] }))
  )
);

/*const store = configureStore({
    reducer: {
        user: userReducer,
        profile: profileReducer,
        appstate: appStateReducer,
        idle,
    },
    // enhancers: [applyMiddleware(load({ states: ["appstate", "user"] }))],
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER,
                ],
            },
        })
            .concat(idleMiddleware)
            .concat(save({ states: ["appstate", "user"] })),*/
/*middleware: [
        // applyMiddleware(load({ states: ["appstate", "user"] })),
        reduxThunk,
        idleMiddleware,
        // applyMiddleware(save({ states: ["appstate", "user"] })),
    ],*/
/*preloadedState: {
        appstate: appStateReducer,
        user: userReducer,
    },*/
/*devTools: {
        persist: true,
    },
});*/

// add redux-idle-monitor to check the user's status on portal. If user is inactive for 15 mins he will be log out
let previousIsAuthorized = false;
// Will start the idle monitoring when the user logs in, and stop it if the user is signed out.
store.subscribe(() => {
  let currentIsAuthorized;
  let state = store.getState();
  // calls a function that selects whether the user is authorized from the current state
  currentIsAuthorized = selectIsAuthorized(state);
  if (currentIsAuthorized !== previousIsAuthorized) {
    previousIsAuthorized = currentIsAuthorized;
    store.dispatch(
      (currentIsAuthorized ? idleActions.start : idleActions.stop)()
    );
  }
});

const selectIsAuthorized = (state) => {
  return state.user.isAuthenticated;
};

export default store;
